export function validateKeepRise(config) {
    if (!config.symbols || !config.symbols.trim()) {
        return "Symbols list is required.";
    }

    const pct = Number(config.percentRiseFromLastBuy);
    if (!Number.isFinite(pct) || pct <= 0) {
        return "Percent rise must be > 0.";
    }

    if (!config.incrementalType) {
        return "Incremental type is required.";
    }

    const inc = Number(config.incrementalValue);
    if (!Number.isFinite(inc) || inc <= 0) {
        return "Incremental value must be > 0.";
    }

    return null;
}
